<template>
    <div class="asset-list-container">
        <div class="items">
            <div class="asset-item" v-for="(item,index) in dataList" :key="index">
                <address>{{item.certificateAddress}}</address>
                <div class="company">{{item.managementEnterprise}}</div>
                <div class="tags">
                    <span>{{item.actualUseFor}}</span>
                    <span>{{item.assetSource}}</span>
                    <span>{{item.hasEstateCertificate=='1'?'有产证':'无产证'}}</span>
                </div>
                <div class="status" v-if="item.contractStatus=='EXPIRED'">
                    <i class="orange"></i>
                    <em>合同到期</em>
                </div>
                <div class="status" v-if="item.contractStatus=='ARREARS'">
                    <i class="red"></i>
                    <em>有欠租合同</em>
                </div>
                <div class="status" v-if="item.contractStatus=='NORMAL'">
                    <i class="green"></i>
                    <em>合同正常</em>
                </div>
                <img class="poi" src="/img/3dmap/poi.png" @click="pointed(item)">
            </div>
        </div>
        <div class="pages">
            <a-pagination size="small" :total="total" :pageSize='10' @change="pageChange" />
        </div>
    </div>
</template>
<script>
export default {
    name:'assetListDv',
    data(){
        return{

        }
    },
    props:{
        dataList:{
            default:function(){
                return []
            },
            type:Array
        },
        total:0
    },
    methods:{
        pageChange(val){
            console.log(val)
            this.$emit('changePage',val)
        },
        pointed(item){
            this.$emit('fixPoi',{lng:item.lng,lat:item.lat})
        }
    }
}
</script>
<style lang="scss" scoped>
.asset-list-container{
    width:320px;
    height: 490px;
    background-color: #fff;
    padding:10px;
    box-sizing: border-box;
    border:1px solid #C0CCDA;
    border-radius: 2px;
    box-shadow: 0 0 0 2px rgba(192,204,218, 0.2);
    .items{
        height:435px;
        overflow-y:auto;
        overflow-x:hidden;
        -ms-overflow-style: none;
    }
    .items::-webkit-scrollbar{
        display:none;
    }
    .asset-item:first-child{
        padding-top:0;
    }
    .asset-item:last-child{
        border-bottom: none;
        padding-bottom: 20px;
    }
    .asset-item{
        position:relative;
        border-bottom: 1px solid #ccc;
        color:#666;
        font-size: 12px;
        padding-bottom: 10px;
        padding-top:10px;
        .poi{
            position:absolute;
            bottom:20px;
            right: 20px;
            width:16px;
            height: 16px;
            cursor: pointer;
        }
        address{
            color:#333;
            font-size: 14px;
            margin-bottom:6px;
        }
        .tags{
            margin:6px 0;
            span{
                display: inline-block;
                border-radius: 4px;
                border:1px solid #1B89D4;
                padding:0 2px;
                margin-right: 5px;
                color:#1B89D4;
            }
        }
        .status{
            i{
                display: inline-block;
                width:8px;
                height:8px;
                border-radius: 50%;
                background-color:red;
                margin-right: 2px;
                vertical-align: middle;
            }
            i.orange{
                background-color:orange;
            }
            i.green{
                background-color:green;
            }
            em{
                vertical-align: middle;
            }
        }
    }
    .pages{
        text-align: center;
        padding:10px 0;
    }
}
</style>


